// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"09ed43c5","413":"0cc75ba7","988":"8adc869f"}[chunkId] + ".chunk.js";
};